import binarySearchString from "../../utils/binarySearchString";
import editorAction from "../../actions/editorAction";
import BlockContainerAction from "../../actions/blockContainerAction";
import { useEditorStateContext } from "../../contexts/EditorContext";
import { useTreeStateContext } from "../../contexts/TreeContext";
import generateObjectId from "../../utils/generateObjectId";
import drawPath from "../../utils/drawPath";
import { useEffect } from "react";

function usePath() {

    const { pathTmp } = useEditorStateContext();

    const { blocks, children } = useTreeStateContext();

    const { resetTmpPath, resetMagnetPosition, updateMouse } = BlockContainerAction();

    const { createPath : createPathAction, deletePath: deletePathAction } = editorAction();

    // Helper function for getting the path information for drawing it
    const searchPath = (path) => {

        //Binary search for fast execution
        const indexNextParent = binarySearchString(blocks, path.parent_block_id, 'object_id');
        if(indexNextParent == null) return/* console.error('Cannot find block_parent for path ', path)*/;
        const indexChild =  binarySearchString(children, path.child_block_id, 'object_id');
        if(indexChild == null) return /*console.error('Cannot find block_child', path)*/;
        const indexParentOfChild =  binarySearchString(blocks, children[indexChild].parent_block_id, 'object_id');
        if(indexParentOfChild == null) return /*console.error('Cannot find block_parent throught block_child', path)*/;

        // '_property' are the information of the in block && 'property' are the information of the out block : the child's one
        return {
            id : path.path_id,
            x : blocks[indexParentOfChild].x,
            y : blocks[indexParentOfChild].y,
            height : blocks[indexParentOfChild].height,
            index : children[indexChild].index,
            _x : blocks[indexNextParent].x,
            _y : blocks[indexNextParent].y,
            _height : blocks[indexNextParent].height,
        }
    }

    const createPath = (block_id) => {
        if(pathTmp == null || pathTmp.parent_block_id == block_id) return;
        const index = binarySearchString(blocks, block_id);
        const block = blocks[index];
        if(block.type && block.type.name == 'scenario') return;
        let path_id = generateObjectId();
        // Need to do a lot action when a path is created
        createPathAction(block_id, path_id, pathTmp.child_block_id) // will update tree state and add a new path but also call the service api to add this path to the server
        resetTmpPath(); // ResetTmpPath
        resetMagnetPosition(); // Need to reset magnet if not done will cause issues on next path creation, like multiple link on a block tha you don't want
        updateMouse(0, 0);
        return true;
    }

    const movePath = (path, coord = {}) => {
        
        const pathRef = document.getElementById(path.path_id);
        const information = searchPath(path);
        if(!information) {
            return
        }
        
        var {x, y, height, index, _x, _y, _height} = information;

        // A little overwrite of coordonates, cause the state have not already been update so the search path function give us some desync information,
        // But doing a sync each time will leak to performance issue so that's why it's donne that wayZ
        if(coord.in) {
            x = coord.in.x;
            y = coord.in.y;
        }

        if(coord.out) {
            _x = coord.out.x;
            _y = coord.out.y;
        }
        
        let { data, stroke } = drawPath(x, y,_x, _y, height,_height, index)
        // Update the path trought dom cause re-render him will cause performance issue
        pathRef?.setAttributeNS(null, 'd', data);
        pathRef?.setAttributeNS(null, 'stroke', stroke);
    }

    // custom handler to move all the paths of a given block
    const movePaths = (paths) => {
        for(var i = 0; i < paths.length; i ++) {
            let path = paths[i];
            let coord = {};

            // path.in && path.out are really important thanks to them we can move multiple path trought multiple blocks, useful for the multiple selection
            if(path.in) coord.in = path.in;
            if(path.out) coord.out = path.out;
            // Move our path
            movePath(path, coord);
        }
    }

    // Find some paths that we need to move in a group of paths who cames from differents blocks
    // Also remove duplicate if find
    const setPaths = (paths, paths_block, x, y, property) => {

        for(var j = 0; j < paths_block.length; j++) {
                    
            let path = paths_block[j];
            let path_index =  paths.map(path_to_move => path_to_move.path_id).indexOf(path.path_id);
            if(path_index === -1) {
                paths.push({...path, [property] : {x : x, y : y}})
                continue;
            }
            
            paths[path_index][property] = {x : x, y : y};
        }
        
        return paths;
    }

    const deletePath = (id) => deletePathAction(id)


    return { searchPath, createPath, movePath, deletePath, movePaths, setPaths }
}

export default usePath;